import { render, staticRenderFns } from "./BlogPostCard.vue?vue&type=template&id=1859f4de&scoped=true"
import script from "./BlogPostCard.vue?vue&type=script&lang=js"
export * from "./BlogPostCard.vue?vue&type=script&lang=js"
import style0 from "./BlogPostCard.vue?vue&type=style&index=0&id=1859f4de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1859f4de",
  null
  
)

export default component.exports